export default {"src":"/_next/static/media/supply-chain.7edac44b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};